import styled from "styled-components";

import Button from "core/Button";
import QuestionIcon from "core/ReusableIcons/Question";
import { regular as regularFont, textMd } from "core/fontStyles";
import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";

export const EditorialMessage = styled.p`
    margin-bottom: ${convertPxToRem({ px: 24 })};
    color: ${colors.primary.diamond};
    ${textMd}

    svg {
        margin-bottom: ${convertPxToRem({ px: -2.5 })};
    }
`;

export const EditorialName = styled.span`
    color: ${colors.accent.darkMode.suenosBuenos};
    display: inline-block;
    margin-right: ${convertPxToRem({ px: 8 })};
    cursor: pointer;
`;

export const EditorialIcon = styled(QuestionIcon)`
    cursor: pointer;
`;

export const GetPhotoButton = styled(Button)`
    &[aria-disabled="true"]:focus {
        outline: none;
        box-shadow: none;
    }
`;
